import { type DeepPartial } from "react-hook-form";

import { DSApi } from "@ds/services/ds-api";
import { parseQueries } from "@ds/utils/query";
import { type ApiService, type ApiServiceConfig } from "@ds/services/types";

interface CampaignsServiceConfig extends ApiServiceConfig {
  api: DSApi;
}

class CampaignsService implements ApiService {
  private config: CampaignsServiceConfig = {
    api: {} as DSApi,
  };

  configure(cfg: CampaignsServiceConfig) {
    this.config = { ...cfg };
  }

  async getCampaigns(queryInfo: QueryInfo, pagination: Pagination) {
    const queries = parseQueries(queryInfo, pagination);
    return this.config.api.get<QueryOutput<Campaign>>("/campaigns/", queries);
  }

  async getCampaign(campaignId: number) {
    return this.config.api.get<Campaign>(`/campaigns/${campaignId}`);
  }

  async createCampaign(campaign: Campaign) {
    return this.config.api.post<Campaign>("/campaigns/", campaign);
  }

  async duplicateCampaign(id: number, name?: string) {
    return this.config.api.post<Campaign>(`/campaigns/${id}/duplicate`, { name });
  }

  async updateCampaigns(ids: number[], data: DeepPartial<Campaign>) {
    return this.config.api.patch<Campaign>("/campaigns/", { ids, data });
  }

  async deleteCampaign(id: number) {
    return this.config.api.delete<Campaign>(`/campaigns/${id}`);
  }

  async deleteCampaigns(ids: number[]) {
    return this.config.api.delete<Campaign>("/campaigns/", { ids });
  }
}

export const campaignsService = new CampaignsService();
